import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CalendarCultivationHierarchyListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-hierarchy-list.response';
import { CalendarHierarchyCardItemComponent } from './calendar-hierarchy-card-item/calendar-hierarchy-card-item.component';
import { CalendarCultivationListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/calendar-cultivation-list.response';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'vw-calendar-hierarchy-card',
    imports: [CalendarHierarchyCardItemComponent, CommonModule],
    templateUrl: './calendar-hierarchy-card.component.html',
    styleUrl: './calendar-hierarchy-card.component.scss'
})
export class CalendarHierarchyCardComponent {
  @Input() hierarchy: CalendarCultivationHierarchyListResponse;
  @Input() showSeed: boolean = true;
  @Input() showHarvest: boolean = true;

  @ViewChild('expandContent') expandContent: ElementRef;

  @Output() cultivationSelected = new EventEmitter<CalendarCultivationListResponse>();

  isOpen = false;

  onParentClick() {
    if (this.hierarchy.cultivations.length > 1) {
      this.isOpen = !this.isOpen;
    } else {
      this.cultivationSelected.emit(this.hierarchy.cultivations[0]);
    }
  }

  onChildClick(cultivation: CalendarCultivationListResponse) {
    if (this.isOpen) {
      this.cultivationSelected.emit(cultivation);
    }
  }
}
